import React, { useEffect, useState, useRef } from 'react';
import { useForm, Controller } from "react-hook-form";
import { FormControl, FormHelperText, TextField, Typography, InputLabel, FormLabel, Paper, Toolbar, Select, MenuItem, Divider, Button, Grid } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import SaveIcon from '@material-ui/icons/Save';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { AcquirerActions, AccountActions, NotificationActions } from '../../../store';

const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px',
        "& h6": {
            fontSize: '12px'
        }
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const acquirersSelector = (state) => state.Acquirers;
const IdentitySelector = (state) => state.Identity;

const AcquirerStepSix = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const accountActions = bindActionCreators(AccountActions, dispatch);
    const acquirerActions = bindActionCreators(AcquirerActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { editing, nowWainting } = useSelector(acquirersSelector);
    const { token } = useSelector(IdentitySelector);

    const { control, errors, handleSubmit, watch } = useForm();
    const password = useRef({});
    password.current = watch("password", "");

    const { classes } = props;

    /**
     *
     * 入力内容変更時の処理
     *
     */
    const onChange = (e) => {
        const currentState = editing.user_account_create_request;
        const { name, value } = e[0].target;

        const permissionPrefix = 'permission';

        if (name.startsWith(permissionPrefix)) {
            var id = name.substring(permissionPrefix.length, name.length);
            if (currentState.permissions[id] == null) {
                return;
            }
            var permissionType = currentState.permissions[id].type;
            var permissionSetting;

            permissionType.selectables.forEach((p) => {
                if (p.value == value) {
                    permissionSetting = p
                    return;
                }
            });
            if (permissionSetting != null) {
                currentState.permissions[id].value = permissionSetting;
            }

            // フォームを更新
            accountActions.modifyAccount(currentState);
        }
        if (name.startsWith('role')) {
            currentState[name] = value;

            accountActions.loadSelectableOrgAndPermissions(token, currentState)
                .then(
                    (data) => {
                        // フォームを更新
                        accountActions.modifyAccount(currentState);
                    }
                );
        }
        else {
            currentState[name] = value;
        }

        return value;
    }

    const handleNext = () => {
        props.handleNext();
    };

    const handleBack = () => {
        props.handleBack();
    };

    var passwordRule = { required: <FormattedMessage id={"Error.Required"} />, pattern: { value: /^((?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])|(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[^a-zA-Z0-9])|(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[^a-zA-Z0-9])|(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^a-zA-Z0-9])).{8,}$/i, message: <FormattedMessage id="Error.AccountPassWordPattern" /> } };
    var passwordConfirmRule = { required: <FormattedMessage id={"Error.Required"} />, validate: value => value === password.current || <FormattedMessage id="Error.AccountPassWordMatchPattern" /> };

    // 区分（OKICAビジネスアカウントロール）は、加盟店の編集モデルを取得時に設定済

    return (
        <form className={classes.form} noValidate>
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <Controller
                        name="username"
                        control={control}
                        defaultValue={editing.user_account_create_request.username}
                        onChange={onChange}
                        rules={{
                            required: <FormattedMessage id={"Error.Required"} />,
                            maxLength: { value: 256, message: <FormattedMessage id="Error.AccountEmailPattern" /> },
                            pattern: { value: /^[a-zA-Z0-9_+-]+(.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/i, message: <FormattedMessage id="Error.Email" /> }
                        }}
                        as={<TextField required fullWidth
                            error={errors.username && true}
                            helperText={errors.username ? errors.username.message : "例) okinawa_taro@okica.jp"}
                            label={<FormattedMessage id={"Account.Username"} />} variant="outlined" />} />

                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="name"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.user_account_create_request.name}
                        rules={{
                            required: <FormattedMessage id={"Error.Required"} />,
                            maxLength: { value: 128, message: <FormattedMessage id="Error.AccountNamePattern" /> }
                        }}
                        as={<TextField required fullWidth variant="outlined"
                            error={errors.name && true}
                            helperText={errors.name ? errors.name.message : "例) 沖縄 太郎"}
                            label={<FormattedMessage id={"Account.Name"} />} />} />
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="password"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.user_account_create_request.password}
                        rules={passwordRule}
                        as={<TextField required fullWidth
                            error={errors.password && true}
                            type="password"
                            helperText={errors.password ? errors.password.message : ""}
                            label={<FormattedMessage id={"Account.Password"} />} variant="outlined" />} />
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="password_repeat"
                        control={control}
                        defaultValue={editing.user_account_create_request.password_repeat}
                        onChange={onChange}
                        rules={passwordConfirmRule}
                        as={<TextField required fullWidth
                            error={errors.password_repeat && true}
                            type="password"
                            helperText={errors.password_repeat ? errors.password_repeat.message : ""}
                            label={<FormattedMessage id={"Account.PasswordRepeat"} />} variant="outlined" />} />
                </Grid>
                <Grid item xs={6}>
                    <FormControl required fullWidth variant="outlined">
                        <InputLabel id="account-role-label"><FormattedMessage id={"Account.Role"} /></InputLabel>
                        <Controller
                            name="role"
                            control={control}
                            onChange={onChange}
                            defaultValue={editing.user_account_create_request.role}
                            rules={{
                                required: <FormattedMessage id={"Error.Required"} />
                            }}
                            as={<Select
                                disabled
                                labelId="account-role-label"
                                id="account-role"
                                label={<FormattedMessage id={"Account.Role"} />}>
                                <MenuItem value={2}><FormattedMessage id="Account.Role.Brand" /></MenuItem>
                                <MenuItem value={3}><FormattedMessage id="Account.Role.Acquirer" /></MenuItem>
                                <MenuItem value={4}><FormattedMessage id="Account.Role.Merchant" /></MenuItem>
                                <MenuItem value={5}><FormattedMessage id="Account.Role.Store" /></MenuItem>
                            </Select>} />
                    </FormControl>
                </Grid>

                <Grid item xs={12}>
                    <Typography component="h2" variant="inherit">{<FormattedMessage id="Account.Permission" />}</Typography>
                    <Divider />
                </Grid>

                {editing.user_account_create_request.availablePermissionTypes.map((permissionType) => {
                    return (
                        <Grid item xs={6} key={permissionType.id}>
                            <FormControl variant="outlined" required fullWidth>
                                <InputLabel id={"permission" + permissionType.id + "-label"}>{permissionType.name}</InputLabel>
                                <Controller
                                    name={"permission" + permissionType.id}
                                    control={control}
                                    defaultValue={editing.user_account_create_request.permissions[permissionType.id] ? editing.user_account_create_request.permissions[permissionType.id].value.value : 0}
                                    onChange={onChange}
                                    rules={{
                                        required: <FormattedMessage id={"Error.Required"} />
                                    }}
                                    as={<Select
                                        labelId={"permission" + permissionType.id + "-label"}
                                        id={"permission" + permissionType.id}
                                        label={permissionType.name}>

                                        {permissionType.selectables.map((permissionValue) => {
                                            return <MenuItem key={permissionValue.value} value={permissionValue.value}>{permissionValue.title}</MenuItem>
                                        })}
                                    </Select>} />
                            </FormControl>
                        </Grid>
                    )
                })}

                <Grid container item xs={12} spacing={2} justify="center">
                    <Grid item xs={6}>
                        <Button fullWidth variant="contained" size="medium"
                            startIcon={<ArrowBackIosIcon />}
                            onClick={handleBack}><FormattedMessage id="Button.Back" /></Button>
                    </Grid>
                    <Grid item xs={6}>
                        <Button fullWidth variant="contained" size="medium" color="primary"
                            onClick={handleSubmit(handleNext)}
                            endIcon={<SaveIcon />}>
                            <FormattedMessage id="Button.Confirm" />
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </form>
    )
}

export default withStyles(style, { withTheme: true })(AcquirerStepSix);
